import { render, staticRenderFns, recyclableRender, components } from "./storage-point.vue?vue&type=template&id=5ddfc117&scoped=true&"
var renderjs
import script from "./storage-point.vue?vue&type=script&lang=js&"
export * from "./storage-point.vue?vue&type=script&lang=js&"
import style0 from "./storage-point.vue?vue&type=style&index=0&id=5ddfc117&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../办公/HBuilderX.3.8.12.20230817/HBuilderX/plugins/uniapp-cli/node_modules/@dcloudio/vue-cli-plugin-uni/packages/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ddfc117",
  null,
  false,
  components,
  renderjs
)

component.options.__file = "shop/pages/storage-point/storage-point.vue"
export default component.exports